module.exports = __webpack_public_path__ + "static/img/1.b0a49e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empresas/1.png
// module id = aTTt
// module chunks = 0